import { createIO } from '../../utils/io';
import { selector as $$ } from '../../utils/selector';
import { narrowQuery, ASSETS_PATH_MAP } from '../../env';
import brightcovePlayerLoader from '@brightcove/player-loader';

export class VideoBg {
  constructor(
    el,
    lang = 'ja',
    context = {
      playingTrigger: '.js-videoBg-trigger'
    }
  ) {
    this.$el = el;
    this.$playingTrigger = $$(context.playingTrigger)[0];

    this.videoPlayer = undefined;

    this.isPlaying = false;
    this.lang = lang;

    this.#init();
  }

  #init() {
    const videoId = narrowQuery.matches ? '6297979618001' : '6293866449001';

    brightcovePlayerLoader({
      refNode: this.$el,
      accountId: '4819125602001',
      playerId: 'ZQnRu9Kj8',
      embedId: 'default',
      videoId,
      options: {
        loop: true,
        autoplay: true,
        playsinliney: true,
        mutedy: true
      }
    })
      .then((success) => {
        this.videoPlayer = success.ref;
        this.#brightcoveReady(this.videoPlayer);
      })
      .catch((error) => {
        const errImg = new Image();
        const errSrc = narrowQuery.matches
          ? ASSETS_PATH_MAP[this.lang] +
            '/assets/static/img/top/img-error_sp.jpg'
          : ASSETS_PATH_MAP[this.lang] + '/assets/static/img/top/img-error.jpg';
        errImg.setAttribute('id', 'not-found');
        errImg.classList.add('Movie__image');
        errImg.src = errSrc;

        this.$el.appendChild(errImg);
      });
  }

  #brightcoveReady(videoPlayer) {
    videoPlayer.on('loadedmetadata', () => {
      videoPlayer.muted(true);
      this.play();
    });

    this.#onPlayOrPause();
  }

  #onPlayOrPause = () => {
    const io = createIO({
      rootMargin: '10% 0px'
    });

    io.observe(this.$playingTrigger, (entry) => {
      if (entry.isIntersecting && !this.isPlaying) {
        this.play();
      } else if (this.isPlaying) {
        this.pause();
      }
    });
  };

  play() {
    this.videoPlayer.play();
    this.isPlaying = true;
  }

  pause() {
    this.videoPlayer.pause();
    this.isPlaying = false;
  }
}
